import React, { useState } from 'react';
import { X, Copy, Check, Download, Twitter, Linkedin, Loader2 } from 'lucide-react';

export default function ShareModal({
  isOpen,
  onClose,
  title = "Share",
  shareUrl,
  imageUrl,
  downloadUrl,
  shareText = "Check this out on TraderBro!",
}) {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const urlToShare = shareUrl || window.location.href;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(urlToShare);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 bg-gray-900/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h3 className="font-bold text-gray-900">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>
        <div className="p-4">
          {imageUrl && (
            <div className="aspect-[1200/630] bg-gray-100 rounded-lg overflow-hidden mb-4 border border-gray-200">
              <img
                src={imageUrl}
                alt="Social Card Preview"
                className="w-full h-full object-cover"
              />
            </div>
          )}
          
          <div className="flex flex-col gap-3">
            <button
              onClick={handleCopyLink}
              className="flex items-center justify-center gap-2 w-full py-2.5 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors"
            >
              {copied ? <Check size={18} /> : <Copy size={18} />}
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
            
            {(downloadUrl || imageUrl) && (
              <a
                href={downloadUrl || imageUrl}
                download="traderbro-social-card.png"
                className="flex items-center justify-center gap-2 w-full py-2.5 bg-white text-gray-700 border border-gray-200 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Download size={18} />
                Download Image
              </a>
            )}
            
            <div className="flex items-center justify-center gap-3 mt-2">
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(shareText)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 bg-blue-50 text-blue-500 rounded-full hover:bg-blue-100 transition-colors"
              >
                <Twitter size={20} />
              </a>
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 bg-blue-50 text-blue-700 rounded-full hover:bg-blue-100 transition-colors"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
